import { FC } from "react"

interface ConnectorFormInputProps {
  label: string
  value: string | number
  onChange: (value: string) => void
  placeholder?: string
  error?: string
  helpText?: string
  type?: "text" | "number" | "url"
  readOnly?: boolean
  required?: boolean
}

const ConnectorFormInput: FC<ConnectorFormInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  helpText,
  type = "text",
  readOnly = false,
  required = false
}) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label} {required && "*"}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        readOnly={readOnly}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          readOnly ? "bg-gray-50 text-gray-700" : "bg-white"
        }`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {helpText && <p className="text-sm text-gray-500 mt-1">{helpText}</p>}
    </div>
  )
}

export default ConnectorFormInput
